import {maxBy} from 'lodash'

export default {
  state: {
    loaded: false,
    university: {},
    layouts: [],
    periods: [],
    showArchived: false,
    selectedTermItem: null,
    unit: null,
    unitPeriod: null,
    id: process.env.UNIVERSITY_ID,
    selectedProgramLevel: 'All'
    // majors: []
    // interestAreas: [],
  },

  mutations: {
    setUniversity(state, u) {
      state.university = u
    },

    setLayouts(state, l) {
      state.layouts = l
      state.loaded = true
    },

    setPeriods(state, p) {
      state.periods = p
    },

    setShowArchived(state, s) {
      state.showArchived = s
    },

    setSelectedTermItem(state, i) {
      state.selectedTermItem = i
    },

    setUnit(state, u) {
      state.unit = u
    },

    setUnitPeriod(state, u) {
      state.unitPeriod = u
    },

    setSelectedProgramLevel(state, pl) {
      state.selectedProgramLevel = pl
    }
  },

  getters: {
    isUnmMain(state) {
      console.log(state.university)
      return state.university && state.university.id == 4158
    },

    // format program and concentrations as a set of "majors"
    majors(state, getters) {
      return state.layouts
        .map(layout => {
          // make sure plan periods only include academic_periods that
          // are also in the list of university periods
          layout.planPeriods = layout.academic_periods
            .filter(p => {
              return getters.periodIds.includes(p.id) && p.plan_count
            })

          layout.planPeriods.forEach(p => {
            p.name = state.periods.find(period => period.id === p.id).name
          })

          layout.planPeriods.sort((a, b) => (a.id - b.id))

          layout.planPeriodIds = layout.planPeriods.map(p => p.id)

          layout.currentPlanPeriod = layout.planPeriods.find(p => p.id === getters.currentPeriod.id)

          layout.currentAcademicPeriod = layout.academic_periods.find(p => p.id === getters.currentPeriod.id)

          return layout
        })
        .filter(layout => {
          const typeCheck = ['program', 'concentration'].includes(layout.type)
          // const planCheck = layout.planPeriodIds.length

          return typeCheck
        })
    },

    termIdentifier(state) {
      return state.university.term_identifier || 'Term'
    },

    // return current majors unless the showArchived flag is true
    currentMajors(state, getters) {
      const majors = getters.majors
      return (state.showArchived ? majors : majors.filter(m => !!m.currentAcademicPeriod)) || []
    },

    // get latest period
    currentPeriod(state) {
      return maxBy(state.periods, p => p.code) || {}
    },

    // get a map of period ids
    periodIds(state) {
      return state.periods.map(p => p.id)
    },

    unitMajor(state) {
      if (!state.unitPeriod) return null
      return state.unitPeriod.period_degree_joins.find(pdj => pdj.degree_type.code === 'MAJOR')
    },

    unitMinor(state) {
      if (!state.unitPeriod) return null
      return state.unitPeriod.period_degree_joins.find(pdj => pdj.degree_type.code === 'MINOR')
    }
  }
}



// WEBPACK FOOTER //
// ./src/state.js